export const teamGridSetup = () => {
    document
        .querySelectorAll('section article.team-member-panel button')
        .forEach((element) => {
            element.addEventListener('click', showBioDetails);
        });

    document.querySelectorAll('.bio-panel-close').forEach((element) => {
        element.addEventListener('click', closeBioDetails);
    });
};

const showBioDetails = (event) => {
    event.preventDefault();
    closeBioDetails();

    const member = event.currentTarget.getAttribute('member');

    // where the bio content will come from
    const id = '#' + event.currentTarget.getAttribute('member');
    const contentSrc = document.querySelector(id).lastChild.firstChild;

    // if this is relative we are below mobile breakpoint
    const testPos = window.getComputedStyle(contentSrc).position !== 'relative';

    if (testPos) {
        // Desktop Breakpoint
        const bioContent = document.createElement('div');
        bioContent.classList.add('team-bio-panel-content', 'w-full', 'border');
        bioContent.innerHTML = contentSrc.innerHTML;

        const panels = document.querySelectorAll('.team-member-panel');

        const insertAfter = (referenceNode, newNode) => {
            referenceNode.parentNode.insertBefore(
                newNode,
                referenceNode.nextSibling
            );

            document
                .querySelector('.team-bio-panel-content .bio-panel-close')
                .addEventListener('click', closeBioDetails);
        };

        let targetPanelIndex = null;
        let targetRowEnd;
        panels.forEach((panel, ix) => {
            if (panel.id === event.currentTarget.getAttribute('member')) {
                targetPanelIndex = ix;
            }

            if (
                !targetRowEnd &&
                panel.classList.contains('row-end') &&
                targetPanelIndex !== null
            ) {
                targetRowEnd = panel;
            }
        });

        // find the end of the row the click occurred in
        insertAfter(targetRowEnd, bioContent);
        setTimeout(() => {
            document
                .querySelector('.team-bio-panel-content .opacity-0')
                .classList.add('opacity-100');
        }, 250);
    } else {
        // Mobile Breakpoint
        // NOTE: In mobile view, the profile image and name should be hidden
        // and replaced by the detail description view.
        document.querySelector('.bio-' + member + '-cover').classList.add('hidden');
        
        // Showing the detail description view
        contentSrc.parentElement.classList.remove('hidden');
        contentSrc.querySelector('.opacity-0').classList.add('opacity-100');
    }
};

const closeBioDetails = (event) => {
    event && event.preventDefault();
    let openpanel = document.querySelector('.team-bio-panel-content');
    if (openpanel) {
        openpanel.remove();
    } else {
        openpanel = document.querySelector('.opacity-0.opacity-100');
        if (openpanel) {
            // The code below is run when the user has already open the detail view
            // closing the detail description view
            openpanel.classList.remove('opacity-100');
            openpanel.closest('.bio-panel').classList.add('hidden');
            
            // Reopening the profile image and name
            document.querySelectorAll('.bio-cover').forEach((member) => {
                console.log(member);
                if (member.classList.contains('hidden')) {
                    member.classList.remove('hidden');
                }
            });
        }
    }

    console.log(openpanel);
};
